import { ProgressNoteData } from "@/modules/patients/detail/progress-note/types/progress-note-fragment-type"
import { formatProgressNoteDocuments } from "@/modules/patients/detail/store/useDocumentStore"
import { isConcludedCarePlanDocument } from "@/modules/patients/libs/is-concluded-care-plan-document"

const hasTreatmentPlanPdf = (progressNote: ProgressNoteData): boolean =>
  isConcludedCarePlanDocument(formatProgressNoteDocuments(progressNote, false).carePlanSummary)

export { hasTreatmentPlanPdf }
